import { useQuery } from '@tanstack/react-query';
import { AzureDevOpsClient } from '../httpClients/AzureDevOpsClient/AzureDevOpsClient';
import { QUERY_KEYS } from './consts';

export const useAzureInstallationsStatusQuery = (options?: {
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.AZURE_INSTALLATIONS_STATUS],
    queryFn: async () => {
      return await AzureDevOpsClient.checkAzureInstallationsStatus();
    },
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    enabled: options?.enabled !== false,
  });
};
